import { has, hasValue } from 'app/shared/global.functions';
import { inject, Injectable } from '@angular/core';
import { UserConfig } from './model/user-configuration.model';
import { LocalStorageService } from './local-storage.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { IAPPLY_CONFIG } from '@iapply/iapply.provider';
import { merge } from 'lodash';

@Injectable({
    providedIn: 'root'
})
export class UserConfigService {
    private readonly _storageService = inject(LocalStorageService)
    private readonly _config = new BehaviorSubject(inject(IAPPLY_CONFIG));

    constructor() {
        let data = this._storageService.getLocalStorageData('user-config');
        if (data) {
            let config = merge({}, this._config.getValue(), JSON.parse(data));
            this._config.next(config);
        }
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for config
     */
    set config(value: any) {
        // Merge the new config over to the current config
        const config = merge({}, this._config.getValue(), value);

        // Execute the observable
        this._config.next(config);

        // Save a copy in local storage for later use
        this._storageService.setLocalStorageData('user-config', config);
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    get config$(): Observable<any> {
        return this._config.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Resets the config to the default
     */
    reset(): void {
        // Set the config
        this._config.next(this.config);
    }
}
